export default __webpack_public_path__ + "static/media/rush.be3ba0e8.jpeg";